function cartReveal(){
  $(document).on('click', '.cart-icon, .ajax-cart .close', function(e) {
    e.preventDefault();
    $('.cart-reaveal').toggleClass('reveal');
  })
}

export default cartReveal();



// WEBPACK FOOTER //
// ../markup/assets/js/cart-reveal.js